module.exports = __webpack_public_path__ + "img/camden-county-logo-White-1.fed16f08.png";